import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=78c5f788&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=ts&"
export * from "./Wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=78c5f788&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5f788",
  null
  
)

export default component.exports